import { REACT_APP_CLOUD_FRONT_FILES, REACT_APP_COUNTRY } from '../config';

/**
 * UWT-81: enlaces legales del pie del portal del cliente.
 *
 * Las URLs salen de `REACT_APP_CLOUD_FRONT_FILES` (base CloudFront del bucket de archivos del
 * ambiente, con el prefijo `<MERCADO>/legal-documents/`) + el nombre de archivo del mercado.
 * Son archivos NUEVOS y versionados, distintos de `privacy_notice.pdf` / `terms_and_conditions.pdf`
 * que usa el flujo de firma: ese flujo no se toca.
 *
 * Un mercado que no figura en el mapa no dibuja enlaces legales.
 */
export type PortalLegalLinkKey = 'privacy' | 'terms';

export interface PortalLegalLink {
  key: PortalLegalLinkKey;
  href: string;
}

/** Nombre de archivo por mercado. Se agrega una entrada por mercado cuando tenga sus PDFs subidos. */
export const PORTAL_LEGAL_FILES: Record<string, Record<PortalLegalLinkKey, string>> = {
  MX: {
    privacy: 'privacy_notice_v1_2025-11.pdf',
    terms: 'terms_and_conditions_2025-11.pdf'
  }
};

/** Orden en el pie: aviso de privacidad primero, términos y condiciones después. */
const LINK_ORDER: PortalLegalLinkKey[] = ['privacy', 'terms'];

export function getPortalLegalLinks(
  market: string = REACT_APP_COUNTRY,
  base: string = REACT_APP_CLOUD_FRONT_FILES
): PortalLegalLink[] {
  const files = PORTAL_LEGAL_FILES[market];
  const root = String(base || '').trim().replace(/\/+$/, '');
  if (!files || !root) return [];
  return LINK_ORDER.map((key) => ({ key, href: `${root}/${files[key]}` }));
}
